/* PhotoHouse dynamic frame preview: existing Shopify media only, no catalog writes. */
(function(){
  'use strict';
  var PRINT_TYPES={
    'Print - rectangle - Portrait':'portrait',
    'Print - rectangle - Landscape':'landscape',
    'Print - Square':'square',
    'Print - Panoramic':'panoramic'
  };
  function list(root,selector){return Array.prototype.slice.call(root.querySelectorAll(selector));}
  function norm(value){
    return String(value||'').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\s+/g,' ').trim();
  }
  function finishOf(value){
    var v=norm(value);
    if(/(?:printing only|print only|no frame|without frame|unframed|ללא מסגרת|הדפסה בלבד|הדפס בלבד)/.test(v))return 'none';
    if(/(?:black|שחור)/.test(v))return 'black';
    if(/(?:wenge|ונגה|וונגה)/.test(v))return 'wenge';
    if(/(?:amber|ענבר)/.test(v))return 'amber';
    return null;
  }
  function cleanFile(url){
    try{return decodeURIComponent(String(url||'').split('?')[0].split('/').pop()).toLowerCase();}
    catch(e){return String(url||'').split('?')[0].split('/').pop().toLowerCase();}
  }
  // The legacy "Gimur_*" filename does not prove a frame remains in the
  // current image. Collection cards already treat these source files as
  // eligible for synthetic frame previews. Keep explicit frame indicators.
  function hasFrameMockup(m){
    var a=norm(m.alt),f=cleanFile(m.src);
    return /(?:frame|framed|wenge|wenga|amber|black|dark.?oak|light.?oak|מסגרת|ונגה|וונגה|ענבר|שחור)/.test(a+' '+f) ||
      /(?:mock.?up|[_-](?:dw|lw|dark|light)[._-]|print[_-]?pack)/.test(f);
  }
  function originalCandidate(m,type){
    if(!m||!m.src||!m.width||!m.height||hasFrameMockup(m))return false;
    var a=norm(m.alt),f=cleanFile(m.src),ratio=m.width/m.height;
    if(!Number.isFinite(ratio)||m.width<450||m.height<400)return false;
    if(/(?:watermark|mockup|mock-up|placeholder|branded|preview|sample|low.?res)/.test(a+' '+f))return false;
    // Merchant's "*-print.jpg" file is often a square display mockup, not raw photo.
    if(/(?:^|[-_])(?:print|printing|pack|preview)(?:[-_.]|$)/.test(f))return false;
    if(/(?:^|[._-])(?:gold|platin|dibond|acryl|plexi|canvas)(?:[._-]|$)/.test(f))return false;
    if(type==='portrait')return ratio>=.48&&ratio<=.89;
    if(type==='landscape')return ratio>=1.14&&ratio<=1.88;
    if(type==='square')return ratio>=.90&&ratio<=1.10;
    if(type==='panoramic')return ratio>=1.90&&ratio<=5.0;
    return false;
  }
  function pickOriginal(data){
    var type=PRINT_TYPES[data.type],media=Array.isArray(data.media)?data.media:[];
    if(!type)return null;
    // Never cover a professionally framed media gallery with a second frame.
    if(media.filter(hasFrameMockup).length>=2)return null;
    // Liquid has already identified and region-cropped this same 1300px
    // print-only source used by collection cards. Trust that exact source only.
    var prepared=media.filter(function(m){
      return m&&m.prepared===true&&m.src&&m.width>=400&&m.height>=400&&!hasFrameMockup(m);
    });
    if(prepared.length===1)return prepared[0];
    if(prepared.length>1)return null;
    var originals=media.filter(function(m){return originalCandidate(m,type);});
    if(originals.length===1)return originals[0];
    if(originals.length>1)return null;
    // Single original photos are sometimes classified as landscape while their
    // artwork is actually portrait (and vice versa). Render the REAL aspect
    // ratio rather than silently suppressing the entire mockup.
    if(media.length===1){
      var m=media[0],file=cleanFile(m&&m.src);
      if(!m||!m.src||!m.width||!m.height||hasFrameMockup(m))return null;
      if(/(?:watermark|mockup|mock-up|placeholder|branded|preview|sample|low.?res)/.test(norm(m.alt)+' '+file))return null;
      if(/(?:^|[-_])(?:print|printing|pack|preview)(?:[-_.]|$)/.test(file))return null;
      if(/(?:^|[._-])(?:gold|platin|dibond|acryl|plexi|canvas)(?:[._-]|$)/.test(file))return null;
      var ratio=m.width/m.height;
      if(m.width>=450&&m.height>=400&&ratio>=0.45&&ratio<=5.0)return m;
    }
    return null;
  }
  function compute(object,container,ratio,finish){
    if(!object||!container)return;
    var w=container.clientWidth,h=container.clientHeight;
    if(w<150||h<150||!Number.isFinite(ratio)||ratio<=0)return;
    var inset=Math.min(w,h)>=590?100:Math.max(24,Math.floor(Math.min(w,h)*0.17));
    // One geometry function for product pages and collection cards. Only
    // the collection frame's components differ: 6px moulding + 10px mat.
    // Both total 16px per edge, identical to the previous 8px + 8px,
    // so the OUTER dimensions stay unchanged while the photo is redistributed.
    // The product page keeps its approved 8px moulding + 15px mat.
    var isCollectionCard=container.hasAttribute('data-ph-cro-frame-stage');
    var edge=finish==='none'?0:(isCollectionCard?6:8);
    var mat=isCollectionCard?10:15;
    var maxW=Math.max(60,w-2*(inset+edge+mat));
    var maxH=Math.max(80,h-2*(inset+edge+mat));
    var imageW=Math.min(maxW,maxH*ratio);
    var imageH=imageW/ratio;
    object.style.setProperty('--ph-auto-edge',edge+'px');
    object.style.setProperty('--ph-auto-mat',mat+'px');
    object.style.setProperty('--ph-auto-image-width',Math.floor(imageW)+'px');
    object.style.setProperty('--ph-auto-image-height',Math.floor(imageH)+'px');
  }
  /* Constrain each product-page gray square to whichever is smaller:
     gallery width or available viewport height below the actual header.
     Reserve space for a thumbnail rail when one is present. */
  function squarePixels(galleryWidth,top,viewportHeight,compact,hasRail){
    if(!Number.isFinite(galleryWidth)||!Number.isFinite(viewportHeight))return 0;
    var reservedTop=Math.max(compact?72:120,top||0);
    var reservedBottom=compact?16:(hasRail?100:22);
    var heightBudget=Math.max(150,viewportHeight-reservedTop-reservedBottom);
    return Math.max(0,Math.floor(Math.min(galleryWidth,heightBudget)));
  }
  function mount(article){
    if(article.dataset.phAutoFrameMounted==='1')return;
    var dataNode=article.querySelector('script[data-ph-auto-frame-data]');
    var stage=article.querySelector('[data-ph-auto-stage]');
    var native=article.querySelector('.ctm_product_gallery_main .filter_product_gallery');
    if(!dataNode||!stage||!native)return;
    var data;
    try{data=JSON.parse(dataNode.textContent||'{}');}catch(e){return;}
    var source=pickOriginal(data);
    if(!source)return;
    var holder=list(article,'.product__variant-holder').find(function(el){
      var label=el.querySelector('label'),select=el.querySelector('select.product__variant');
      return select&&label&&/(?:frame|מסגר|finish|גימור)/i.test(norm(label.textContent));
    });
    var frameSelect=holder&&holder.querySelector('select.product__variant');
    if(!frameSelect)return;
    var main=stage.parentElement;
    var artwork=stage.querySelector('[data-ph-auto-image]');
    var object=stage.querySelector('[data-ph-auto-object]');
    var zoom=stage.querySelector('[data-ph-auto-zoom]');
    if(!artwork||!object||!zoom)return;
    article.dataset.phAutoFrameMounted='1';
    var ratio=source.width/source.height,loaded=false,current=null;
    var dialog=null,scene=null,closeButton=null,returnFocus=null;
    function setFinish(node,finish){
      node.classList.remove('ph-auto-frame--none','ph-auto-frame--black','ph-auto-frame--wenge','ph-auto-frame--amber');
      node.classList.add('ph-auto-frame--'+finish);
    }
    function closeAuto(){
      article.classList.remove('ph-auto-frame-active');
      stage.hidden=true;
      native.inert=false;
      native.removeAttribute('aria-hidden');
      if(main){
        main.style.removeProperty('--ph-auto-square-height');
        main.style.removeProperty('--ph-auto-square-size');
      }
    }
    function fitSquare(){
      if(!main)return;
      var gallery=main.closest('.product__gallery')||main.parentElement;
      if(!gallery)return;
      var bounds=gallery.getBoundingClientRect();
      var currentTop=main.getBoundingClientRect().top;
      var compact=window.innerWidth<1024;
      var rail=!compact&&!!gallery.querySelector('.ph-v7__rail.is-ready');
      var height=window.innerHeight||document.documentElement.clientHeight;
      var px=squarePixels(bounds.width,currentTop,height,compact,rail);
      if(px<150)return;
      var value=px+'px';
      if(main.style.getPropertyValue('--ph-auto-square-size')!==value){
        main.style.setProperty('--ph-auto-square-size',value);
      }
      if(main.style.getPropertyValue('--ph-auto-square-height')!==value){
        main.style.setProperty('--ph-auto-square-height',value);
      }
    }
    function layout(){
      if(!loaded||stage.hidden)return;
      fitSquare();
      compute(object,stage,ratio,current);
      if(scene&&dialog&&dialog.open){
        var clone=scene.querySelector('.ph-auto-frame-object');
        if(clone)compute(clone,scene,ratio,current);
      }
    }
    var queued=false;
    function queueLayout(){
      if(queued)return;
      queued=true;
      window.requestAnimationFrame(function(){queued=false;layout();});
    }
    function sync(){
      if(!loaded)return;
      var finish=finishOf(frameSelect.value);
      if(!finish){current=null;closeAuto();return;}
      current=finish;
      setFinish(object,finish);
      stage.hidden=false;
      article.classList.add('ph-auto-frame-active');
      // Set the viewport-fitted square before painting, not the gallery width.
      fitSquare();
      native.inert=true;
      native.setAttribute('aria-hidden','true');
      queueLayout();
    }
    function buildDialog(){
      dialog=document.createElement('dialog');
      dialog.className='ph-auto-frame-dialog';
      dialog.dir=/^he/i.test(document.documentElement.lang||'')?'rtl':'ltr';
      dialog.setAttribute('aria-label',dialog.dir==='rtl'?'הדמיית התמונה והמסגרת':'Framed print mockup');
      closeButton=document.createElement('button');
      closeButton.className='ph-auto-frame-close';
      closeButton.type='button';
      closeButton.textContent='×';
      closeButton.setAttribute('aria-label',dialog.dir==='rtl'?'סגירה':'Close');
      scene=document.createElement('div');
      scene.className='ph-auto-frame-modal-scene';
      dialog.appendChild(closeButton);
      dialog.appendChild(scene);
      document.body.appendChild(dialog);
      closeButton.addEventListener('click',function(){dialog.close();});
      dialog.addEventListener('click',function(event){if(event.target===dialog)dialog.close();});
      dialog.addEventListener('close',function(){
        if(returnFocus&&returnFocus.isConnected)returnFocus.focus();
      });
    }
    zoom.addEventListener('click',function(){
      if(!loaded||!current||typeof HTMLDialogElement==='undefined'||typeof HTMLDialogElement.prototype.showModal!=='function')return;
      if(!dialog)buildDialog();
      if(dialog.open)return;
      scene.textContent='';
      var clone=object.cloneNode(true);
      clone.removeAttribute('data-ph-auto-object');
      scene.appendChild(clone);
      returnFocus=zoom;
      dialog.showModal();
      compute(clone,scene,ratio,current);
      closeButton.focus();
    });
    frameSelect.addEventListener('change',sync);
    if(window.jQuery&&window.jQuery.fn)window.jQuery(frameSelect).on('change.phAutoFrame',sync);
    article.addEventListener('click',function(ev){
      if(ev.target.closest('.ph-v2__option--frame'))window.requestAnimationFrame(sync);
    });
    window.addEventListener('resize',queueLayout,{passive:true});
    if(window.ResizeObserver){
      var observer=new ResizeObserver(queueLayout);
      observer.observe(stage);
    }
    /* The legacy handoff hid the native gallery before the *displayed* img
       had finished loading, leaving a blank stage on slow/cache-miss loads.
       Wait for the actual visible image to decode before activating the stage.
       Failed image or invalid aspect always keeps the native gallery usable. */
    function imageReady(){
      if(!article.isConnected||!artwork.complete||artwork.naturalWidth<100||artwork.naturalHeight<100)return;
      var displayedRatio=artwork.naturalWidth/artwork.naturalHeight;
      if(Math.abs(displayedRatio-ratio)/ratio>.035){loaded=false;closeAuto();return;}
      loaded=true;
      sync();
    }
    artwork.onload=imageReady;
    artwork.onerror=function(){loaded=false;closeAuto();};
    var photo=new Image();
    photo.onload=function(){
      if(!article.isConnected)return;
      if(photo.naturalWidth<100||photo.naturalHeight<100){closeAuto();return;}
      var actual=photo.naturalWidth/photo.naturalHeight;
      if(Math.abs(actual-ratio)/ratio>.035){closeAuto();return;}
      artwork.alt=data.title||'';
      artwork.src=source.src;
      if(artwork.complete&&artwork.naturalWidth>0)imageReady();
    };
    photo.onerror=function(){loaded=false;closeAuto();};
    photo.src=source.src;
  }
  /* Collection print mockups share the *same* compute() function, actual
     object/mat/image DOM and frame texture CSS as the product-page preview.
     Only the data source differs: a verified original photo selected in Liquid,
     never a second attempt to pick a variant in the browser. */
  var cardObserver=null, cardResizeObserver=null, cardQueued=false, cardResizeBound=false;
  function measureCardFrames(){
    list(document,'[data-ph-cro-frame-stage]').forEach(function(stage){
      var object=stage.querySelector('[data-ph-cro-frame-object]');
      var ratio=Number(stage.getAttribute('data-ph-cro-ratio'));
      var finish=stage.getAttribute('data-ph-cro-finish')||'wenge';
      if(!object||!Number.isFinite(ratio)||ratio<=0)return;
      if(cardResizeObserver && stage.dataset.phCroResizeObserved!=='1'){
        stage.dataset.phCroResizeObserved='1';
        cardResizeObserver.observe(stage);
      }
      compute(object,stage,ratio,finish);
    });
  }
  function queueCardFrames(){
    if(cardQueued)return;
    cardQueued=true;
    window.requestAnimationFrame(function(){
      cardQueued=false;
      measureCardFrames();
    });
  }
  function mountCollectionFrames(){
    if(!cardResizeObserver && window.ResizeObserver){
      cardResizeObserver=new ResizeObserver(queueCardFrames);
    }
    if(!cardObserver && window.MutationObserver){
      var root=document.querySelector('#shopify-section-collection')||
               document.querySelector('#page-content');
      if(root){
        cardObserver=new MutationObserver(function(mutations){
          if(mutations.some(function(m){return m.addedNodes.length>0;}))
            queueCardFrames();
        });
        cardObserver.observe(root,{childList:true,subtree:true});
      }
    }
    if(!cardResizeBound){
      window.addEventListener('resize',queueCardFrames,{passive:true});
      cardResizeBound=true;
    }
    queueCardFrames();
  }
  function start(){
    if(!document.body||!document.body.classList.contains('ph-v1'))return;
    if(document.body.classList.contains('template-collection')||
       document.body.classList.contains('template-index')){
      mountCollectionFrames();
    }
    if(document.body.classList.contains('template-product')&&
       !document.body.classList.contains('template-product-portfolio')){
      list(document,'article.product.page-section').forEach(mount);
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
  else start();
  document.addEventListener('shopify:section:load',start);
}());